<script>
import MailingList from "@/components/Admin/MailingList.vue";
import DataRouteGuards from "@/mixins/DataRouteGuards";
import FormMixin from "@/mixins/FormMixin";

export default {
  name: "AdminMailingList",
  components: { MailingList },
  mixins: [DataRouteGuards, FormMixin],
  data() {
    return {};
  },
  computed: {},
};
</script>

<template>
  <div v-if="itemLoaded && routeDataLoaded" class="admin-mailing-list">
    <b-row>
      <b-col>
        <h1>
          <em>{{ $tc("mailing_lists.mailing_list", 1) | capitalize }}</em>
        </h1>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <mailing-list :mailing-list="item" />
      </b-col>
    </b-row>
  </div>
</template>

<style scoped lang="scss"></style>
